import { render } from "./busquedaavanzada.vue?vue&type=template&id=0bef3c5a&scoped=true"
import script from "./busquedaavanzada.vue?vue&type=script&lang=js"
export * from "./busquedaavanzada.vue?vue&type=script&lang=js"

import "./busquedaavanzada.vue?vue&type=style&index=0&id=0bef3c5a&scoped=true&lang=css"

import exportComponent from "C:\\HAZAKPUEBLA\\cedispage2.0jacve\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bef3c5a"]])

export default __exports__